export enum BadgesType {
  Promoted = 'promoted',
  Boosted = 'boosted',
  Featured = 'featured',
  StaffPick = 'staff_pick',
  NoProfit = 'no_profit',
  Owner = 'owner',
  Partner = 'partner',
  Published = 'published',
  MultiFarm = 'multiFarm',
  SingleFarm = 'singleFarm',
  Ailm = 'Ailm',
  Alm = 'Alm',
  Stable = 'stable',
  BlueChip = 'blue_chip',
  Correlated = 'correlated',
  Volatile = 'volatile',
  ETH_BTC = 'eth_btc',
}

export const BADGES_FILTERS_NAMES = {
  [BadgesType.Promoted]: 'Promoted',
  [BadgesType.Boosted]: 'BOOST!',
  [BadgesType.Featured]: 'Featured',
  [BadgesType.NoProfit]: '100% Compound',
  [BadgesType.Partner]: 'Partner',
  [BadgesType.StaffPick]: 'Staff Pick',
  [BadgesType.Owner]: 'Owner',
  [BadgesType.Published]: 'Published',
  [BadgesType.MultiFarm]: 'Strategy',
  [BadgesType.SingleFarm]: 'Farm',
  [BadgesType.Ailm]: 'AiLM',
  [BadgesType.Alm]: 'ALM',
  [BadgesType.Stable]: 'Stable',
  [BadgesType.BlueChip]: 'Blue Chip',
  [BadgesType.Correlated]: 'Correlated',
  [BadgesType.Volatile]: 'Volatile',
  [BadgesType.ETH_BTC]: 'ETH/BTC',
};
